module.exports = __webpack_public_path__ + "static/icons/img-banner-1.7b65457.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-home/img-banner-1.png
// module id = pUjm
// module chunks = 1